import { useCallback } from 'react'
import { setUIHCookie as setUIHCookieFunction } from '@moonpig/web-shared-utils'

export const useSetUIHCookie = () => {
  const setUIHCookie = useCallback(
    ({
      product,
      facets,
    }: {
      product: {
        id: string
        category: { id: string | number }
        isSponsored?: boolean
        internallyPromoted?: boolean
      }
      facets?: {
        group: string
        facetKey: string
      }[]
    }) =>
      setUIHCookieFunction({
        product,
        facets: facets || [],
      }),
    [],
  )

  return { setUIHCookie }
}
